import { useTranslationTyped } from 'i18n/i18n'

export function EmptyListPlaceholder() {
  const emailAddress = 'support@breakoutlearning.com'
  const { tt } = useTranslationTyped()
  return (
    <div className="relative flex h-full items-center justify-center rounded-3xl bg-surface">
      <div className="z-10 my-36 bg-surface text-center md:my-0 md:mb-36">
        <h2 className="font-bold">{tt.student_library.empty_placeholder()}</h2>
        <p className="my-4 px-10 text-xs whitespace-pre-wrap">
          {tt.student_library.empty_placeholder_description()}
        </p>
        <p className="text-label-medium">
          <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
        </p>
      </div>
      <div className="absolute bottom-0 hidden md:block">
        <img
          src="/assets/images/auth1.png"
          alt=""
          className="mt-5 aspect-auto h-full max-h-[30vh] w-full max-w-[30vw]"
        />
      </div>
    </div>
  )
}
